<ng-container *ngIf="isShowingResults === false">
  <div cdkDropList class="option-list" (cdkDropListDropped)="drop($event)">
    <div *ngFor="let option of options; let i = index" cdkDrag
         [cdkDragDisabled]="isSubmitted"
         [ngClass]="{
          'neutral': isSubmitted && _card.isNoCorrect,
          'correct': isSubmitted && !_card.isNoCorrect && option.item.correctOrder === i,
          'wrong': isSubmitted && !_card.isNoCorrect && option.item.correctOrder !== i
         }"
         class="option-box">
      <div>{{ option.item.text }}</div>
      <img *ngIf="!isSubmitted" src="/images/conference/drag.svg">
    </div>
  </div>

  <app-card-button *ngIf="!isSubmitted" [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate" (onSubmit)="submit()"></app-card-button>
  <app-card-button *ngIf="isEnableSwitchViews && isSubmitted" (click)="showResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_STATISTICS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
<ng-container *ngIf="isShowingResults === true && results">
  <app-card-results [results]="results"></app-card-results>
  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()" [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
